module.exports = __webpack_public_path__ + "assets/img/expand-sidebar-icon.8ec020e5.svg";